"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const API = {
    list: '/api/ac/v2/service/management/encryption/key/published/list',
    upload: '/api/file/key'
};
class ServiceEncryptionKeyAPI {
    constructor(httpClient) {
        this._httpClient = httpClient;
    }
    async getListPublicKey(serviceId, page = 0, limit = 10) {
        const query = {
            serviceId,
            page,
            limit
        };
        const res = await this._httpClient.get(API.list, { params: query });
        const data = {
            result: null,
            paging: {
                page,
                limit,
                total: 0,
            },
            entities: {},
        };
        if (!res.data || !res.data.data) {
            return data;
        }
        const resBody = res.data.data;
        data.result = resBody.result;
        data.paging = resBody.paging;
        data.entities = resBody.entities;
        return data;
    }
}
exports.default = ServiceEncryptionKeyAPI;
